<template>
  <v-autocomplete
    no-data-text="Danh sách trống"
    v-bind="this.$attrs"
    item-text="name"
    :items="teachers"
    item-value="id"
    @change="onChange"
    v-on:input="$emit('input', $event)"
    @update:search-input="update"
  ></v-autocomplete>
</template>

<script>
import { Teacher } from '@/plugins/api'

export default {
  data: () => ({
    teachers: []
  }),
  props: {
    filter: Object,
    options: Object,
    defaultTeachers: Array
  },
  created() {
    this.teachers = this.defaultTeachers
    this.fetchAllTeachers()
  },
  methods: {
    async fetchAllTeachers() {
      this.teachers = await Teacher.fetch({
        ...this.filter
      })
    },
    async update() {},
    onChange(data) {
      this.$emit('change', data)
    }
  }
}
</script>
